import React from "react";
import { motion } from "framer-motion";

// Hero image
import galleryHero from "../assets/Photo-Gallery-Cover-photo.jpg";

// Gallery images
import photo1 from "../assets/photog1.jpg";
import photo2 from "../assets/photog2.jpg";
import photo3 from "../assets/photog3.jpg";
import photo4 from "../assets/photog4.jpg";
import photo5 from "../assets/photog5.jpg";
import photo6 from "../assets/photog6.jpg";
import photo7 from "../assets/photog7.jpg";
import photo8 from "../assets/photog8.jpg";
import photo9 from "../assets/photog9.jpg";

const PhotoGallery = () => {

  const photos = [
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8,
    photo9,
  ];

  return (
    <div className="bg-black text-white min-h-screen">

      {/* ================= HERO ================= */}
      <section
        className="relative h-[60vh] flex items-center justify-center text-center bg-cover bg-top"
        style={{ backgroundImage: `url(${galleryHero})` }}
      >

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/65"></div>

        {/* Decorative Glow */}
        <div className="absolute top-20 left-10 w-40 h-40 bg-lime-400/10 rounded-full blur-3xl"></div>

        <div className="absolute bottom-10 right-10 w-60 h-60 bg-lime-400/10 rounded-full blur-3xl"></div>


        {/* Hero Content */}
        <div className="relative z-10 max-w-4xl mx-auto px-6">

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-lime-400 uppercase tracking-[0.3em] text-sm font-semibold mb-5"
          >
            Moments From The Field
          </motion.p>


          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            PHOTO <span className="text-lime-400">GALLERY</span>
          </motion.h1>


          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
          >
            A glimpse into our conservation work, field activities,
            community engagement and moments from across Odisha.
          </motion.p>

        </div>

      </section>


      {/* ================= PHOTO GALLERY ================= */}
      <section className="py-20 bg-gray-950">

        <div className="w-11/12 md:w-4/5 mx-auto">

          {/* Section Heading */}
          <div className="text-center mb-14">

            <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
              Captured Moments
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-lime-400">
              OUR GALLERY
            </h2>

            <div className="w-20 h-1 bg-lime-400 mx-auto mt-5"></div>

          </div>


          {/* ================= MASONRY GALLERY ================= */}
          <div
            className="
              columns-1
              sm:columns-2
              lg:columns-3
              gap-6
            "
          >

            {photos.map((photo, index) => (

              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  y: 40,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                viewport={{
                  once: true,
                  amount: 0.1,
                }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.05,
                }}
                whileHover={{
                  scale: 1.02,
                }}
                className="
                  relative
                  mb-6
                  break-inside-avoid
                  overflow-hidden
                  rounded-2xl
                  bg-gray-900
                  shadow-xl
                  border
                  border-gray-800
                  hover:border-lime-400/60
                  transition-all
                  duration-300
                  group
                "
              >

                {/* Image */}
                <img
                  src={photo}
                  alt={`ACoT Gallery ${index + 1}`}
                  className="
                    w-full
                    h-auto
                    object-contain
                    block
                    transition-transform
                    duration-500
                    group-hover:scale-105
                  "
                />


                {/* Hover Overlay */}
                <div
                  className="
                    absolute
                    inset-0
                    bg-black/0
                    group-hover:bg-black/20
                    transition-all
                    duration-300
                    pointer-events-none
                  "
                />

              </motion.div>

            ))}

          </div>

        </div>

      </section>

    </div>
  );
};

export default PhotoGallery;